export const edgesData = [
  {
    id: "77.75.79.738-147.32.3.202",
    source: "77.75.79.138",
    target: "147.32.3.202",
    type: "straight",
  },
  {
    id: "91.198.174.192-195.113.89.35",
    source: "195.113.89.35",
    target: "91.198.174.192",
    type: "straight",
  },
  {
    id: "91.198.174.192-147.32.3.202",
    source: "147.32.3.202",
    target: "91.198.174.192",
    type: "straight",
  },
  {
    id: "91.198.174.192-217.31.205.50",
    source: "91.198.174.192",
    target: "217.31.205.50",
    type: "straight",
  },
  {
    id: "82.208.6.9-217.31.205.50",
    source: "217.31.205.50",
    target: "82.208.6.9",
    type: "straight",
  },
  {
    id: "82.208.6.9-91.198.174.192",
    source: "91.198.174.192",
    target: "82.208.6.9",
    type: "straight",
  },
  {
    id: "193.85.9.76-217.31.205.50",
    source: "217.31.205.50",
    target: "193.85.9.76",
    type: "straight",
  },
  {
    id: "193.85.9.76-2001:1488:0:3::2",
    source: "193.85.9.76",
    target: "2001:1488:0:3::2",
    type: "straight",
  },
  {
    id: "147.32.3.202-217.31.205.50",
    source: "147.32.3.202",
    target: "217.31.205.50",
    type: "straight",
  },
  {
    id: "2001:718:1e03:622::12-2001:1488:0:3::2",
    source: "2001:1488:0:3::2",
    target: "2001:718:1e03:622::12",
    type: "straight",
  },
  {
    id: "192.168.1.1-193.85.9.76",
    source: "193.85.9.76",
    target: "192.168.1.1",
    type: "straight",
  },
  {
    id: "82.208.6.9-193.85.9.76",
    source: "82.208.6.9",
    target: "193.85.9.76",
    type: "straight",
  },
  {
    id: "57.200.0.1-82.208.6.9",
    source: "82.208.6.9",
    target: "57.200.0.1",
    type: "straight",
  },
  {
    id: "82.208.6.9-208.67.222.222",
    source: "82.208.6.9",
    target: "208.67.222.222",
    type: "straight",
  },
  {
    id: "222.173.190.239-2002:c0a8:101::1",
    source: "222.173.190.239",
    target: "2002:c0a8:101::1",
    type: "straight",
  },
  {
    id: "57.200.0.1-2002:c0a8:101::1",
    source: "57.200.0.1",
    target: "2002:c0a8:101::1",
    type: "straight",
  },
  {
    id: "57.200.0.1-208.67.222.222",
    source: "208.67.222.222",
    target: "57.200.0.1",
    type: "straight",
  },
  {
    id: "208.67.222.222-57.200.0.1",
    source: "2002:c0a8:101::1",
    target: "208.67.222.222",
    type: "straight",
  },
  {
    id: "222.173.190.239-208.67.222.222",
    source: "222.173.190.239",
    target: "208.67.222.222",
    type: "straight",
  },
  {
    id: "195.113.27.221-222.173.190.239",
    source: "195.113.27.221",
    target: "222.173.190.239",
    type: "straight",
  },
  {
    id: "208.67.222.222-2620:0:862:ed1a::1",
    source: "2620:0:862:ed1a::1",
    target: "208.67.222.222",
    type: "straight",
  },
  {
    id: "172.16.0.1-2001:718:1202:240::201",
    source: "172.16.0.1",
    target: "2001:718:1202:240::201",
    type: "straight",
  },
  {
    id: "185.158.64.12-2001:718:1202:240::201",
    source: "185.158.64.12",
    target: "2001:718:1202:240::201",
    type: "straight",
  },
  {
    id: "45.87.28.93-2001:718:1202:240::201",
    source: "45.87.28.93",
    target: "2001:718:1202:240::201",
    type: "straight",
  },
  {
    id: "45.87.28.93-2002:c0a8:101::1",
    source: "45.87.28.93",
    target: "2002:c0a8:101::1",
    type: "straight",
  },
  {
    id: "45.87.28.93-2001:718:1e05:604::50",
    source: "45.87.28.93",
    target: "2001:718:1e05:604::50",
    type: "straight",
  },
  {
    id: "195.113.76.22-2002:c0a8:101::1",
    source: "195.113.76.22",
    target: "2002:c0a8:101::1",
    type: "straight",
  },
];
